import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
} from '@mui/material';
import { motion } from 'framer-motion';

// Gallery images from public/gallery directory
const galleryImages = [
  { 
    img: '/gallery/kitchen.jpeg', 
    title: 'Kuchyně',
    description: 'Moderní a plně vybavená kuchyně'
  },
  { 
    img: '/gallery/kitchen2.jpeg', 
    title: 'Kuchyně - Detail',
    description: 'Detailní pohled na kuchyni'
  },
  { 
    img: '/gallery/livingroom.jpeg', 
    title: 'Obývací Pokoj',
    description: 'Prostorný obývací pokoj s výhledem'
  },
];

const Gallery: React.FC = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography 
            variant="h3" 
            component="h1" 
            gutterBottom 
            align="center" 
            sx={{ mb: 1 }}
          >
            Galerie Apartmánu
          </Typography>
          <Typography 
            variant="h6" 
            color="text.secondary" 
            align="center" 
            sx={{ mb: 6 }}
          >
            Prohlédněte si náš krásný apartmán
          </Typography>

          <Grid container spacing={3}>
            {galleryImages.map((item, index) => (
              <Grid 
                item 
                xs={12} 
                md={6} 
                lg={4} 
                key={item.title}
              >
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Card 
                    sx={{ 
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: 2,
                      overflow: 'hidden',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-8px)',
                      },
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="300"
                      image={item.img}
                      alt={item.title}
                      sx={{
                        objectFit: 'cover',
                      }}
                    />
                    <CardContent sx={{ flexGrow: 1, bgcolor: 'background.paper' }}>
                      <Typography 
                        gutterBottom 
                        variant="h5" 
                        component="h2"
                        sx={{ fontWeight: 600 }}
                      >
                        {item.title}
                      </Typography>
                      <Typography 
                        variant="body2" 
                        color="text.secondary"
                      >
                        {item.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Gallery; 